import React, { useEffect, useState } from "react"
import { IFloatingRateDto } from "../../../../types/company/IFloatingRateDto"
import { CommonInput } from "../../../common/element/fields/CommonInput"
import { IErrorModel } from "../../../../types/error/IErrorModel"
import * as TrinityAPI from "../../../../requests/TrinityAPI"
import { getFieldError } from "../../../common/CommonHelper"

export const RatePopUp: React.FC<{
  userId?: number
  companyId?: string
  bankId?: string
  rate: IFloatingRateDto | undefined
  hidePopUp: () => void
}> = ({ userId, companyId, bankId, rate, hidePopUp }) => {
  const [errors, setErrors] = useState<IErrorModel>()
  const [localRate, setLocalRate] = useState<IFloatingRateDto>()
  const [sending, setSending] = useState(false)

  useEffect(() => {
    setLocalRate(rate)
  }, [rate])

  const submit = () => {
    if (!localRate || sending) return
    setSending(true)
    const rateToSend = { ...localRate }
    rateToSend.amount = rateToSend.amount?.toString().replaceAll(" ", "")
    rateToSend.rate = rateToSend.rate?.toString().replaceAll(" ", "")
    rateToSend.onTopAmount = rateToSend.onTopAmount?.toString().replaceAll(" ", "")
    if (companyId && bankId) {
      TrinityAPI.createFloatingRate(companyId, bankId, rateToSend, response => {
        if (response.status === 200) {
          setSending(false)
          hidePopUp()
        } else {
          setErrors(response.data)
          setSending(false)
        }
      })
    } else if (userId) {
      TrinityAPI.createClientFloatingRate(userId, rateToSend, response => {
        if (response.status === 200) {
          setSending(false)
          hidePopUp()
        } else {
          setErrors(response.data)
          setSending(false)
        }
      })
    }
  }

  return (
    <section className="popup-forms">
      <div className="container-popup-forms">
        <button className="close-btn-card" onClick={hidePopUp} />
        <div className="popup-card">
          <h4 className="heading-chapter">Создать условие</h4>
          <div className="flex-row-24">
            <fieldset>
              <legend>Условие</legend>
              <select
                className="input-form"
                onChange={e => setLocalRate({ ...localRate, operator: e.target.value })}
                value={localRate?.operator}
              >
                <option value="">Выберите условие</option>
                <option value=">">&gt;</option>
                <option value="<">&lt;</option>
                <option value=">=">&gt;=</option>
                <option value="<=">&lt;=</option>
                <option value="=">=</option>
              </select>
              {getFieldError(errors, "operator") ? (
                <p className="error-form">{getFieldError(errors, "operator")}</p>
              ) : (
                <></>
              )}
            </fieldset>
            <CommonInput
              typeName={"number"}
              label={"Сумма"}
              placeholder={"Сумма"}
              name={"amount"}
              value={rate?.amount?.toString()}
              errorModel={errors}
              _callback={e => setLocalRate({ ...localRate, amount: e })}
            />
          </div>
          <div className="flex-row-24">
            <CommonInput
              typeName={"number"}
              label={"Процент"}
              placeholder={"5"}
              name={"rate"}
              value={rate?.rate?.toString()}
              errorModel={errors}
              _callback={e => setLocalRate({ ...localRate, rate: e })}
            />
          </div>
          {rate?.type === "AMOUNT" ? (
            <div className="flex-row-24">
              <CommonInput
                typeName={"number"}
                label={"Фикс. сумма USD"}
                placeholder={"500"}
                name={"rate"}
                value={rate?.onTopAmount?.toString()}
                errorModel={errors}
                _callback={e => setLocalRate({ ...localRate, onTopAmount: e })}
              />
            </div>
          ) : (
            <></>
          )}
          <div className="flex-row-24">
            <button className="btn" onClick={submit}>
              {sending ? "Подождите..." : "Сохранить"}
            </button>
            <button className="btn grey-btn" onClick={hidePopUp}>
              Отменить
            </button>
          </div>
        </div>
      </div>
    </section>
  )
}
